import 'css-chunksrc/client/pages/projectPage/sideBar/styles.scss';export default {
  "sideBar": "_sideBar_arejd_1",
  "navigation": "_navigation_arejd_10",
  "item": "_item_arejd_15",
  "selectedLink": "_selectedLink_arejd_27",
  "icon": "_icon_arejd_27",
  "name": "_name_arejd_33",
  "link": "_link_arejd_39",
  "externalLinksList": "_externalLinksList_arejd_66"
};